import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    NetworkInterface,
    DhcpdConfigServer,
    DhcpdConfigList,
} from "userful-chronos-app-common-js/dist/models/config/networkConnections";
import configStore from "../networkConfigStore";

export const cleanNotSetValues = (objects: any[]): any[] => {
    return objects.map(cleanValue);
};

const cleanValue = (value: any): any => {
    if (Array.isArray(value)) {
        return value.map(cleanValue);
    }

    if (typeof value === "object" && value !== null) {
        return cleanObject(value);
    }

    return value === "NOT_SET" ? "" : value;
};

const cleanObject = (obj: any): any => {
    const result: any = {};

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = cleanValue(obj[key]);
        }
    }

    return result;
};

export const convertInterfacesToDhcpdConfigServer = (interfaces: StringID[]): DhcpdConfigServer[] => {
    console.debug("convertInterfacesToDhcpdConfigServer");
    const dhcp = configStore.getState().networkConnections.dhcp || [];

    const dhcpdConfigServers: DhcpdConfigServer[] = [];

    for (let i = 0; i < interfaces.length; i++) {
        const foundIndex = dhcp.findIndex((item) => item.interfaceID.value === interfaces[i].value);

        if (foundIndex < 0) {
            const dhcpdConfigServer: DhcpdConfigServer = {
                interfaceID: interfaces[i],
                dhcpConfigType: "NOT_SET",
                networkAddress: { value: "" },
                defaultLeaseTimeSeconds: 5,
                maxLeaseTimeSeconds: 5,
                rangeStartAddress: { value: "" },
                rangeEndAddress: { value: "" },
                dnsServers: [],
                netMask: { value: "" },
                gateway: { value: "" },
                enabled: false,
            };
            dhcpdConfigServers.push(dhcpdConfigServer);
        } else {
            dhcpdConfigServers.push(dhcp[foundIndex]);
        }
    }

    console.debug(dhcpdConfigServers);
    return dhcpdConfigServers;
};

export const convertDhcpdConfigListToDhcpdConfigServer = (list: DhcpdConfigList): DhcpdConfigServer[] => {
    console.debug("convertDhcpdConfigListToDhcpdConfigServer");
    const dhcp = configStore.getState().networkConnections.dhcp;

    const dhcpdConfigServers: DhcpdConfigServer[] = [];

    for (let i = 0; i < list.configList.length; i++) {
        const dhcpdConfigServer: DhcpdConfigServer = {
            interfaceID: list.configList[i].interfaceID,
            dhcpConfigType: list.configList[i].dhcpConfigType,
            networkAddress: list.configList[i].networkAddress,
            defaultLeaseTimeSeconds: list.configList[i].defaultLeaseTimeSeconds,
            maxLeaseTimeSeconds: list.configList[i].maxLeaseTimeSeconds,
            rangeStartAddress: list.configList[i].rangeStartAddress,
            rangeEndAddress: list.configList[i].rangeEndAddress,
            dnsServers: list.configList[i].dnsServers,
            netMask: list.configList[i].netMask,
            gateway: list.configList[i].gateway,
            enabled: true,
        };

        dhcpdConfigServers.push(dhcpdConfigServer);
    }

    if (dhcp.length > 0) {
        for (let i = 0; i < dhcp.length; i++) {
            const foundIndex = dhcpdConfigServers.findIndex(
                (item) => item.interfaceID.value === dhcp[i].interfaceID.value,
            );
            if (foundIndex < 0) {
                dhcpdConfigServers.push(dhcp[i]);
            }
        }
    }

    console.debug(dhcpdConfigServers);
    return dhcpdConfigServers;
};

export const removeDhcpdConfigServer = (interfaceID: StringID): DhcpdConfigServer[] => {
    console.debug("removeDhcpdConfigServer");
    const dhcp = configStore.getState().networkConnections.dhcp;

    const dhcpdConfigServers: DhcpdConfigServer[] = [];

    if (dhcp.length > 0) {
        for (let i = 0; i < dhcp.length; i++) {
            const dhcpServer = { ...dhcp[i] };

            if (dhcpServer.interfaceID.value !== interfaceID.value) {
                dhcpdConfigServers.push(dhcpServer);
            } else {
                dhcpServer.enabled = false;
                dhcpServer.networkAddress = { value: "" };
                dhcpServer.netMask = { value: "" };
                dhcpdConfigServers.push(dhcpServer);
            }
        }
    }

    console.debug(dhcpdConfigServers);
    return dhcpdConfigServers;
};
